module.exports = __webpack_public_path__ + "img/WarningIcon.13fb2e6d.svg";